export default __webpack_public_path__ + "static/media/banquet.a70ede30.svg";